import { Injectable, signal } from '@angular/core';

@Injectable({
	providedIn: 'root',
})
export class RestLoggingService {
	currentDashboard = signal<string | null>(null);
}
